// Flattens an object to an array of tuples of flattened params and their respective values.
// Excludes null values.
//
// @example
//   let params = {
//     "data": {
//       "attributes": {
//         "selected-id-class": "dl",
//         "government-id-files": [
//           {
//             "page": "front",
//             "capture-method": "upload",
//           }
//         ]
//       },
//       "type": "verification/government-id",
//       "id": nil,
//     }
//   };
//
//   flattenRequestBody(params)
//   # [
//   #   [ "data[attributes][selected-id-class]", "dl" ],
//   #   [ "data[attributes][government-id-files][0][page]", "front" ],
//   #   [ "data[attributes][government-id-files][1][capture-method]", "upload" ],
//   #   [ "data[type]", "verification/government-id" ],
//   # ]
//
// Reference:
// https://mensfeld.pl/2012/01/converting-nested-hash-into-http-url-params-hash-version-in-ruby/
export const flattenRequestBody = (
  value: any,
  key: string | null = null,
  output: Array<[string, any]> = [],
) => {
  const valueType = Object.prototype.toString.call(value);
  if (valueType === '[object Object]') {
    for (const k in value) {
      flattenRequestBody(value[k], key ? `${key}[${k}]` : k, output);
    }
  } else if (valueType === '[object Array]') {
    for (let i = 0; i < value.length; i++) {
      flattenRequestBody(value[i], `${key}[${i}]`, output);
    }
  } else if (String(value) === 'undefined' || String(value) === 'null') {
    // NOTE: we intentionally use String(value) === 'undefined instea of valueType === '[object Undefined]'
    // for broader browser compatibility.
    // For some reason, some browsers do NOT return Valuetype as [object Undefined].
    //
    // Intentionally do nothing. This avoids problem of null's being removed from
    // requests unintentionally via `compacts` and whatnot.`
  } else {
    output.push([key as string, value]);
  }
  return output;
};

/**
 * unescape + encodeURIComponent handle non-Latin Unicode characters, but
 * produces characters like 'Ã©' when encoding characters like 'é'.
 * btoa accounts for these characters, but fails on non-Latin characters.
 * @see https://developer.mozilla.org/en-US/docs/Glossary/Base64#solution_1_%E2%80%93_escaping_the_string_before_encoding_it
 */
export const base64EncodeUnicode = (str: string) => {
  try {
    return btoa(unescape(encodeURIComponent(str)));
  } catch {
    return 'Failed to encode input';
  }
};
